/**
 * User: herbert
 * Date: 01.12.15
 * Time: 12:55
 */

/*eslint  smells/no-complex-switch-case: 0*/

import * as config from '../../config.js';

/**
 * creates a new StelePart which can be a <strike>Stele itself,</strike> a Modul or an Element contained in an Modul
 * @param{StelePartCfg} cfg configuration entry to build Stele from
 * @constructor
 */
function StelePart(cfg) {
	this.cfg = cfg;
	/**@type{Boolean} only added temporary*/ this.temporary = false;
	/**@type{String}*/ this.name = cfg.name;
	/**@type{Boolean}*/ this.container = cfg.container;
	/**@type{Array.<StelePart>}*/ this.children = null;
	/**@type{Number} if higher than index put spacer before the compoment */ this.position = null;
	if (cfg.container) {
		/**@type{Boolean}*/this.backCover = false;
		/**@type{Number} Rotation in 5° */ this.rotation = 0;
	}
	if(cfg.container && cfg.childs && cfg.childs.length > 0 && !cfg.childs[0].hasOwnProperty('cfg')) {
		this.children = [];
		for(let i=0; i<cfg.childs.length; i++) {
			this.children.push(new StelePart(cfg.childs[i]));
		}
	} else {
		this.children = cfg.container ? (cfg.childs ? cfg.childs : []) : null;
	}
	if(!cfg.container) {
		switch(cfg.name) {
			case config.PART_ELEMENT_TWINSPOT_NAME:
					// x,y -1 .. +1
				this.a = {type: config.TS_SPOT, x: 0, y: 0};
				this.b = {type: config.TS_SPOT, x: 0, y: 0};
				this.k3000 = true;
				break;
			case config.PART_ELEMENT_FASSADE_500_NAME:
				this.type = config.F_25;
				this.horiz = config.F_H_SYM;
				this.vert = config.F_V_STRONG;
				this.k3000 = true;
				break;
			case config.PART_MODUL_WEGE2_NAME:
			case config.PART_MODUL_WEGE_NAME:
				//  neue Daten für Tritec Sky, silber/gold und die 2k-Farben
				//  type ist jetzt schon für inhaltlich direction genutzt, das muss man beibehalten um alte configs zu laden
				//   bei type daher auch die neuen ASYM_PEDESTRIAN und ASYM_STREET erfassen
				//  k2xxx erlaubt goldenen Reflektor, ansonsten den silbernen
				//  bei sky === false sind 2200K und die ASYM_xxx-Type verboten
				// die werte im store bei den set-Funktionen entsprechend korrigieren,
				//   also wenn die 2k2-Farbe gewählt wird automatisch sky auf true setzen
				//   oder wenn eine der neuen ASYM_xxx gewählt wird sky auf true setzen
				//   und wenn gold ausgeählt wird, wird k2xxx true (und im Falle von Ambient k3000 false)
				this.rotation = 0; // kann man auch drehen wie Container
				this.type = config.W_SYM;
				this.k3000 = true;
				/**@type{Boolean}*/ this.k2xxx = false;
				/**@type{Boolean}*/ this.sky = false;
				/**@type{Boolean}*/ this.gold = false;
				break;
			case config.PART_ELEMENT_VERT_NAME:
				this.k3000 = true;
				break;
			case config.PART_MODUL_KAMERA_NAME:
				this.type = config.C_BOSCH;
				break;
			case config.PART_ELEMENT_GOBO_NAME:
				this.type = config.G_45;
				this.power = config.G_W_45;
				break;
			default:
				// nop
		}
	}
}

export default StelePart;
